import { EditContactPanel } from '@features/profile/components/edit-contact-panel/EditContactPanel';
import { useProfileNavigation } from '@features/profile/hooks/use-profile-navigation/useProfileNavigation';
import * as React from 'react';

const EditContactRoute = React.memo((): React.ReactElement => {
  const { navigateToPersonalInformation } = useProfileNavigation();

  return <EditContactPanel onClose={navigateToPersonalInformation} />;
});

EditContactRoute.displayName = 'EditContactRoute';

export { EditContactRoute };
